import GrowthProspectsComponent from '../Components/Growth/GrowthProspectsComponent';

function GrowthProspectsPage() {
  return <GrowthProspectsComponent />;
}

export default GrowthProspectsPage;